import { render, staticRenderFns } from "./PracticeSession.vue?vue&type=template&id=1a576fc1&scoped=true"
import script from "./PracticeSession.vue?vue&type=script&lang=js"
export * from "./PracticeSession.vue?vue&type=script&lang=js"
import style0 from "./PracticeSession.vue?vue&type=style&index=0&id=1a576fc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a576fc1",
  null
  
)

export default component.exports